"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  visible: false,
  prevVisible: false,
  disabled: false,
  childNodes: [],
  sideBarNode: null,
  toggle: function toggle() {},
  show: function show() {},
  hide: function hide() {},
  setContext: function setContext() {},
  getChildNodes: function getChildNodes() {}
});

exports.default = _default;